import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface VwShortcut {
  keys: string[];
  description: string;
}

@Component({
  selector: 'app-keyboard-shortcuts-overlay',
  templateUrl: './keyboard-shortcuts-overlay.component.html',
  styleUrls: ['./keyboard-shortcuts-overlay.component.scss'],
})
export class KeyboardShortcutsOverlayComponent {
  @Input() open = false;
  @Output() close = new EventEmitter<void>();

  // Only real, wired-up shortcuts — nothing documented here that the app
  // doesn't actually do (see default-layout.component.ts's keydown handler).
  shortcuts: VwShortcut[] = [
    { keys: ['Ctrl', 'K'], description: 'Open the command palette — jump to any page' },
    { keys: ['?'], description: 'Show this list of keyboard shortcuts' },
    { keys: ['/'], description: 'Jump to the global search box' },
    { keys: ['Esc'], description: 'Close this dialog, or whichever popup/dropdown is open' },
  ];

  dismiss(): void {
    this.close.emit();
  }
}
